module.exports = __webpack_public_path__ + "assets/img/xueshengduan.8f7660a5.png";